import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M20 5.5C20 7.433 16.4183 9 12 9C7.58172 9 4 7.433 4 5.5C4 3.567 7.58172 2 12 2C16.4183 2 20 3.567 20 5.5Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M12 15.5C12.338 15.5 12.6711 15.4908 12.9981 15.473L17.0994 9.77947C15.6163 10.2439 13.8549 10.5 12 10.5C9.63401 10.5 7.42029 10.0834 5.74192 9.34911C5.10541 9.07064 4.50676 8.72937 4 8.31654V12C4 13.933 7.58172 15.5 12 15.5ZM8 13.5C8.55228 13.5 9 13.0523 9 12.5C9 11.9477 8.55228 11.5 8 11.5C7.44772 11.5 7 11.9477 7 12.5C7 13.0523 7.44772 13.5 8 13.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.0754 16.9999L12 17C9.63401 17 7.42029 16.5834 5.74192 15.8491C5.10541 15.5706 4.50676 15.2294 4 14.8165V18.5C4 20.433 7.58172 22 12 22C13.0981 22 14.1445 21.9032 15.0971 21.7281C15.0804 21.6011 15.0776 21.4708 15.0897 21.3392L15.2942 19.1251H13.7847C13.1279 19.1251 12.5264 18.7574 12.227 18.1728C12.0386 17.8047 11.9898 17.3898 12.0754 16.9999ZM9 19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19C7 18.4477 7.44772 18 8 18C8.55228 18 9 18.4477 9 19Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M19 9.79765C19.3168 9.91624 19.515 10.2322 19.4839 10.569L19.1786 13.8751H21.7847C22.0662 13.8751 22.3239 14.0327 22.4522 14.2832C22.5805 14.5337 22.5577 14.835 22.3932 15.0634L17.4408 21.9384C17.2431 22.2129 16.8862 22.321 16.5694 22.2025C16.2526 22.0839 16.0544 21.7679 16.0855 21.4311L16.3908 18.1251H13.7847C13.5032 18.1251 13.2454 17.9675 13.1171 17.7169C12.9888 17.4664 13.0116 17.1651 13.1761 16.9367L18.1285 10.0617C18.3262 9.78723 18.6832 9.67907 19 9.79765Z"
      fill="currentColor"
    />
  </Icon>
));

export default BuildCache;
